import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "addons-details" }
const _hoisted_2 = { class: "addons-details__title" }
const _hoisted_3 = { class: "h1" }
const _hoisted_4 = { class: "addons-details__subtitle" }
const _hoisted_5 = {
  key: 0,
  class: "caption-medium"
}
const _hoisted_6 = {
  key: 1,
  class: "caption-medium"
}
const _hoisted_7 = { class: "addons-details__buttons" }
const _hoisted_8 = {
  href: "/docs/offerte_msc.pdf",
  target: "_blank"
}
const _hoisted_9 = { class: "addons-details__buttons-item" }
const _hoisted_10 = { class: "button-small" }
const _hoisted_11 = { class: "addons-details__actions" }

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { AddonType } from "@/struct/AddonsStruct";
import { PropType } from "@vue/runtime-core";
import BaseButton from "@/components/base/BaseButton.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddonsDetails',
  props: {
  chosenAddon: {
    type: Object as PropType<AddonType>,
    required: true,
  },
  isActive: {
    type: Boolean,
    default: false,
  },
},
  emits: ["action", "close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { t } = useI18n();

const emitAction = (addon: AddonType) => {
  emit("action", addon);
};

const returnBtnTitle = computed(() =>
  props.isActive ? t("common.actions.disable") : t("common.actions.connect")
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.chosenAddon.name), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (__props.chosenAddon.activation_price === '0.00')
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(t)("common.labels.free")), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(Math.floor(parseInt(__props.chosenAddon.activation_price))) + "₽ " + _toDisplayString(_unref(t)("common.labels.perMonth")), 1))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("a", _hoisted_8, [
        _createElementVNode("button", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)("common.labels.offer")), 1),
          _createVNode(BaseIcon, {
            name: "download",
            class: "addons-details__buttons-item__icon"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(BaseButton, {
        title: returnBtnTitle.value,
        color: __props.isActive ? 'grey' : 'primary',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emitAction(__props.chosenAddon)))
      }, null, 8, ["title", "color"])
    ])
  ]))
}
}

})